export const locationPaths = {
  LOCATION_CREATE: "create",
  LOCATION_EDIT: ":id",
  LOCATION_ID: (id) => id,
  LOCATION_DELETE: "delete/:id",
  LOCATION_DELETE_ID: (id) => `delete/${id}`,
  LOCATION_KDS: "kds",
  LOCATION_KDS_CREATE: "kds/create",
  LOCATION_KDS_ID: (id) => `kds/${id}`,
  LOCATION_KDS_EDIT: (id) => `kds/${id}/edit`,
  LOCATION_KDS_EDIT_PAGE: "kds/:id/edit",
};
